import { InboxOutlined } from '@ant-design/icons'
import React from 'react'
import { useHistory } from 'react-router-dom'

const Duedate = (props) => {
  const { data, word } = props
  const history = useHistory()
  const goEditproject = (idproject) => {
    history.push({
      pathname: `/project/${idproject}/edit`,
    })
  }
  return (
    <div className="let-in-duedate-container-main">
      <h3 className="title-duedate">{word['Upcoming_Due_Date']}</h3>
      {data.notdue?.length !== 0 && data?.notdue ? (
        <div className="container-mapping-duedate">
          {data.notdue?.map((item) => {
            return (
              <div className="box-duedate-styles">
                <div className="item-style">
                  <span className="small">{word['Project_Name']}</span>
                  <div style={{ display: 'grid' }}>
                    <p
                      className="cutter-text-line-1"
                      style={{ cursor: 'pointer' }}
                      onClick={() => goEditproject(item.id)}
                    >
                      {item.name}
                    </p>
                  </div>
                </div>
                <div className="group-for-responsive">
                  <div className="item-style">
                    <span className="small">{word['Planed_Closured_Date']}</span>
                    <p>{item.closure}</p>
                  </div>
                  <div className="item-style">
                    <span className="small">{word['Day_Left']}</span>
                    <p>{item.day_left}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <div className="emytystate edit-height-emptystate-summary">
          <InboxOutlined className="inbox" />
          <p>
            {word['No']} {word['Upcoming_Due_Date']}
          </p>
        </div>
      )}
    </div>
  )
}
export default Duedate
